/**
 * Outbound links, in one place.
 *
 * Only destinations that exist. This file used to carry a `docs` family
 * pointing at `outfalakcheckout.com/docs/*` and an `apiReference` beside it —
 * every one of them a 404. Documentation was going to move into the Laravel
 * site and never did, and the platform is moving off that app now, so the links
 * were sending merchants to a page nobody was ever going to write. The setup
 * steps they were meant to supplement already live on the integration screens
 * themselves.
 *
 * Nothing is added back here without opening it in a browser first.
 */

const SITE = 'https://outfalakcheckout.com'

export const links = {
  /**
   * The website embed — one script tag and a few data attributes.
   *
   * `/sdk/v2.js` is what this said until it was checked: a 404, inside a
   * snippet built for copying and pasting, so every merchant who followed the
   * custom-website guide shipped a script tag that fetched nothing. This path
   * is the file that is actually served, and it is served by nginx from
   * `/var/www/outfalakcheckout.com/site/public/` rather than by the PHP app.
   *
   * Not to be confused with `/embed/outfalak-checkout.js`, which is the Shopify
   * storefront embed: it derives everything from the theme at runtime and
   * exposes no configuration, so it does nothing on a site that is not Shopify.
   *
   * On the API's host, not `SITE`: the script calls the origin it was loaded
   * from, and only the API knows the keys this dashboard issues. Loaded from
   * the marketing domain it asks Laravel, which answers every key "not valid".
   */
  sdk: 'https://api.outfalakcheckout.com/embed/outfalak.js',

  /**
   * The plugin's page on the WordPress.org plugin directory.
   *
   * This is the install path to lead with. WordPress' own updater is the only one
   * that needs no explanation and no file: Plugins → Add New → search, install,
   * activate — and it is what a merchant who has never heard of us will try first.
   *
   * Verified open before it was added, per the rule at the top of this file. Note
   * what it does *not* change: the plugin header carries
   * `Update URI: https://outfalakcheckout.com`, so a plugin installed from here
   * still takes its updates from our own manifest rather than from this page.
   */
  wordpressOrgPlugin: 'https://wordpress.org/plugins/outfalak-checkout-for-woocommerce/',

  support: 'mailto:support@outfalakcheckout.com',
  whatsapp: 'https://wa.me/919876543210',
} as const
